var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.775,
    height: 81.748,
    viewBox: "0 0 87.775 81.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.2,84.183C84.671,77.413,75.921,74.113,72.9,73.049c-3.321-1.171-8.047-1.448-11.091-2.129-1.746-.383-4.279-1.341-5.131-2.363s-.341-10.5-.341-10.5a31.576,31.576,0,0,0,2.427-4.62,59.587,59.587,0,0,0,1.788-8.068s1.746,0,2.363-3.066c.66-3.342,1.7-4.641,1.575-7.132-.128-2.448-1.469-2.384-1.469-2.384s1.3-3.555,1.448-10.921C64.66,13.122,57.8,4.5,45.394,4.5c-12.581,0-19.287,8.622-19.1,17.371.17,7.366,1.426,10.921,1.426,10.921s-1.341-.064-1.469,2.384c-.128,2.491.915,3.789,1.575,7.132.6,3.066,2.363,3.066,2.363,3.066a59.586,59.586,0,0,0,1.788,8.068,31.576,31.576,0,0,0,2.427,4.62s.511,9.473-.341,10.5-3.385,1.98-5.131,2.363c-3.044.681-7.77.958-11.091,2.129C14.824,74.113,6.074,77.413,4.541,84.183a1.7,1.7,0,0,0,1.682,2.065h78.32A1.7,1.7,0,0,0,86.2,84.183Z",
    transform: "translate(-4.501 -4.5)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.651 40.874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.182,18.905a3.612,3.612,0,1,1-3.612-3.612A3.612,3.612,0,0,1,21.182,18.905Z",
    transform: "translate(-5.507 -8.665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.708,10.891H23.284a1.02,1.02,0,0,1-.754-.339c-1.784-2-2.456-2.676-3.185-2.676H13.974c-.735,0-1.457.678-3.248,2.683a1,1,0,0,1-.748.333H9.721v-.5a.5.5,0,0,0-.5-.5H7.585a.5.5,0,0,0-.5.5v.5H6.611A2.037,2.037,0,0,0,4.5,12.819V23.876a2.175,2.175,0,0,0,2.1,2.092h20.1a2.014,2.014,0,0,0,1.916-2.092V12.819A1.872,1.872,0,0,0,26.708,10.891ZM16.813,23.48a5.371,5.371,0,1,1,5.114-5.114A5.376,5.376,0,0,1,16.813,23.48Zm5.78-8.946a.817.817,0,1,1,.817-.817A.815.815,0,0,1,22.593,14.534Z",
    transform: "translate(-4.5 -7.875)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfiIcon);
export default __webpack_public_path__ + "static/media/selfiIcon.6ac99f56.svg";
export { ForwardRef as ReactComponent };